var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',[_c('elwrapper',{attrs:{"label":"Name","midtext":""}},[_c('f-text',{attrs:{"disabled":true},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_c('elwrapper',{attrs:{"label":"Image","midtext":""}},[_c('img',{attrs:{"src":_vm.image,"width":"100%","alt":"Preview"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }